import React from "react";
import SlidePanel from "../add_customer/SlidePanel";
import { X } from "lucide-react";

const GuarantorAddedSuccessfully = ({
  isGuarantorAddedSuccessfully,
  handleClose,
  selectedCandidate,
  loanGuarantAmount,
}) => {
  return (
    <SlidePanel isOpen={isGuarantorAddedSuccessfully} onClose={handleClose}>
      <div className="relative flex flex-col h-full bg-white rounded-[12px]">
        {/* Close */}
        <button onClick={handleClose} className="absolute top-2 right-2 z-10">
          <X size={25} strokeWidth={1.5} className="text-[#202020]" />
        </button>

        <div className="flex flex-col justify-center items-center flex-1 px-10">
          {/* Success Icon */}

          <div className="w-[64px] h-[64px] rounded-full bg-[#CFE7FF] flex items-center justify-center">
            <svg width="32" height="32" viewBox="0 0 24 24" fill="none">
              <path
                d="M5 13L10 18L19 7"
                stroke="#0B4D86"
                strokeWidth="2.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </div>

          {/* Title */}

          <h2 className="mt-8 text-[16px] font-[600] text-center text-[#000000]">
            Guarantor Added Successfully!
          </h2>

          {/* Description */}

          <p className="mt-4 text-center text-[14px] text-[#4A4747]">
            <span className="font-[400]">{selectedCandidate?.name}</span> has
            been linked to this loan <br /> account for{" "}
            <span className="font-[400]">
              KES{" "}
              {Number(loanGuarantAmount).toLocaleString("en-US", {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
              })}
            </span>
          </p>
        </div>

        {/* Button */}

        <div className="px-6 pb-8">
          <button
            onClick={handleClose}
            className="w-full h-[54px] rounded-lg bg-[#0B4D86] text-white text-[16px] font-medium"
          >
            Done
          </button>
        </div>
      </div>
    </SlidePanel>
  );
};

export default GuarantorAddedSuccessfully;
